import { render, staticRenderFns } from "./PaquetesImportBloquear.vue?vue&type=template&id=a0dc9bae&scoped=true"
import script from "./PaquetesImportBloquear.vue?vue&type=script&lang=js"
export * from "./PaquetesImportBloquear.vue?vue&type=script&lang=js"
import style0 from "./PaquetesImportBloquear.vue?vue&type=style&index=0&id=a0dc9bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dc9bae",
  null
  
)

export default component.exports